'use client'

import { useUserStore } from '@/stores/user-store'
import { cn } from '@/utils/tailwind/utils'

const CompanyInfo = () => {
  const isAdmin = useUserStore((state) => state.isAdmin)
  const company = useUserStore((state) => state.company)

  return (
    <>
      {isAdmin && company && (
        <div
          className={cn(
            'absolute right-4 top-[65px] z-40 min-w-[250px]',
            'rounded-lg border-2 border-nriched-blue bg-white px-4 pb-2 pt-6 shadow-lg',
          )}>
          <span className="absolute left-3 top-2 text-xs font-normal text-slate-500">Selected company:</span>
          <span className="font-museoSlab font-bold text-nriched-blue lg:text-3xl">{company?.name}</span>
        </div>
      )}
    </>
  )
}

export default CompanyInfo
